import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

interface AuthState {
  isAuthenticated: boolean;
  msalInitialized: boolean;
  name: string | null;
  username: string | null;
  roles: string[];
}

const initialState: AuthState = {
  isAuthenticated: false,
  msalInitialized: false,
  name: null,
  username: null,
  roles: [],
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuth(
      state,
      action: PayloadAction<{ name: string | null; username: string | null; roles: string[] }>,
    ) {
      state.isAuthenticated = true;
      state.msalInitialized = true;
      state.name = action.payload.name;
      state.username = action.payload.username;
      state.roles = action.payload.roles;
    },
    clearAuth(state) {
      state.isAuthenticated = false;
      state.name = null;
      state.username = null;
      state.roles = [];
    },
    setMsalInitialized(state) {
      state.msalInitialized = true;
    },
  },
});

export const { setAuth, clearAuth, setMsalInitialized } = authSlice.actions;
export default authSlice.reducer;
